import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHoudiniComponent } from './simple-icons-houdini.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHoudiniComponent ],
    exports:      [ SimpleIconsHoudiniComponent ],
    bootstrap:    []
})
export class SimpleIconsHoudiniModule {}
